import React, { createContext, PropsWithChildren } from 'react';

import { BBUILocale } from '../types';
import { makeBBUILocale } from '../utils';

export type LocaleContextType = {
    locale: string;
    bbLocale: BBUILocale;
};

export const LocaleContext = createContext<LocaleContextType>({
    locale: 'en',
    bbLocale: 'en',
});

export function LocaleProvider({ locale, children }: PropsWithChildren<{ locale: string }>) {
    return (
        <LocaleContext.Provider value={{ locale, bbLocale: makeBBUILocale(locale) }}>{children}</LocaleContext.Provider>
    );
}
